import { AudienceSelections, CountryCode, OwnershipType, StoreRecord } from "../types/store";

export function uniqueRegions(stores: StoreRecord[]) {
  return [...new Set(stores.map((store) => store.region))].sort();
}

export function uniqueCountries(stores: StoreRecord[]) {
  return [...new Set(stores.map((store) => store.country))].sort() as CountryCode[];
}

export function uniqueFranchiseGroups(stores: StoreRecord[]) {
  return [...new Set(stores.map((store) => store.franchiseGroup).filter(Boolean))].sort() as string[];
}

export function ownershipOptions(stores: StoreRecord[]) {
  return [...new Set(stores.map((store) => store.ownershipType))].sort() as OwnershipType[];
}

export function collectAudienceStoreIds(
  stores: StoreRecord[],
  selections: AudienceSelections,
) {
  const selectedIds = new Set<string>();

  for (const store of stores) {
    if (selections.countries.includes(store.country)) {
      selectedIds.add(store.id);
    }

    if (selections.regions.includes(store.region)) {
      selectedIds.add(store.id);
    }

    if (selections.ownershipTypes.includes(store.ownershipType)) {
      selectedIds.add(store.id);
    }

    if (store.franchiseGroup && selections.franchiseGroups.includes(store.franchiseGroup)) {
      selectedIds.add(store.id);
    }
  }

  return selectedIds;
}

export function uniqueRecipientEmails(stores: StoreRecord[]) {
  return [...new Set(stores.flatMap((store) => store.emails))].sort();
}
